<template>
  <div class="operation-table-container col-12">
    <base-spinner v-if="loading" />
    <div v-else class="col-12 mt-2">
      <div class="custom-nav-tabs invoice-status-tabs mb-3">
        <b-tabs v-model="invoiceTabIndex" content-class="mt-0" @input="onInvoiceTabChange">
          <b-tab
            v-for="tab in invoiceStatusTabs"
            :key="tab.value"
            :title="tab.label"
          />
        </b-tabs>
      </div>
      <div class="row align-items-center mb-2">
        <div class="col-6">
          <h5 class="result">{{ rows }} {{ $t("results") }}</h5>
        </div>
        <div class="col-6">
          <div
            class="d-flex justify-content-end align-items-center mb-2 mb-lg-0"
          >
            <div class="me-2">
              {{ $t("group-by") }}
            </div>
            <div class="me-2 multiple-options-selection">
              <div
                class="handler d-flex align-items-center justify-content-between form-control"
                @click.stop="toggleGroupByMenu"
              >
                <div class="place-holder">
                  {{ group_by_options?.find((each) => each.selected)?.label }}
                </div>
                <img
                  :src="require(`@/assets/images/icons/chevron-down.svg`)"
                  alt="chevron-down"
                  :style="{
                    transform: open_group_by_menu ? 'rotate(180deg)' : '',
                  }"
                />
              </div>
              <div
                v-if="open_group_by_menu"
                v-click-outside="toggleGroupByMenu"
                class="options p-3"
                :style="
                  isLangRtl
                    ? 'left: 0px; width: 220px'
                    : 'right: 0px; width: 220px'
                "
              >
                <div
                  v-for="(option, index) in group_by_options"
                  :key="index"
                  :class="
                    index < group_by_options.length - 1
                      ? 'option cursor-pointer mb-2 pb-2'
                      : 'cursor-pointer'
                  "
                  @click="selectGroupByOption(option)"
                >
                  <b v-if="option?.selected">
                    {{ option?.label }}
                  </b>
                  <span v-else>{{ option?.label }}</span>
                </div>
              </div>
            </div>
            <div :class="[isLangRtl ? 'me-3' : 'me-1']">
              <base-button
                variant="secondary"
                class="me-2 filter__btn"
                v-b-toggle.sidebar-backdrop
                @mouseenter="filterBtnHovered = true"
                @mouseleave="filterBtnHovered = false"
              >
                <img
                  :src="
                    filterBtnHovered
                      ? require(`@/assets/images/icons/funnel-simple-bold-svgrepo-com.png`)
                      : require(`@/assets/images/icons/funnel-simple-bold-svgrepo-com.png`)
                  "
                  alt="filter"
                />
              </base-button>
            </div>
            <div style="position: relative" class="multiple-options-selection">
              <base-button
                id="operations_filter_btn"
                variant="secondary"
                class="filter__btn"
                @click="toggleFormBuilder"
              >
                <img
                  :src="require(`@/assets/images/icons/form-builder.svg`)"
                  alt="form-builder"
                  height="16px"
                />
              </base-button>
              <div
                v-if="open_form_builder"
                v-click-outside="toggleFormBuilder"
                class="options p-3"
                :style="
                  isLangRtl
                    ? 'left: 0px; width: 280px'
                    : 'right: 0px; width: 280px'
                "
              >
                <div
                  v-for="(option, index) in fields"
                  :key="index"
                  :class="'option d-flex align-items-center cursor-pointer mb-2 pb-2'"
                  @click="selectField(option)"
                >
                  <input
                    type="checkbox"
                    :name="option.key"
                    :checked="option.selected"
                    :disabled="
                      fields.filter((each) => each.selected).length === 1
                    "
                    class="me-2"
                  />
                  <div>
                    {{ option?.label }}
                  </div>
                </div>
                <div
                  class="d-flex align-items-center cursor-pointer mt-2"
                  @click="resetFieldSelection"
                >
                  <img
                    :src="require('@/assets/images/icons/trash-icon.svg')"
                    alt="delete image"
                    class="me-2"
                  />
                  <div>
                    {{ $t("reset-selection") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="filter-drivers">
            <b-sidebar
              id="sidebar-backdrop"
              :backdrop-variant="variant"
              bg-variant="white"
              backdrop
              shadow
              :right="!isLangRtl"
              @hidden="$emit('resetSearch')"
            >
              <div class="px-3 py-2">
                <h4 class="filter-drivers__head">{{ $t("filter-by") }}</h4>
                <hr />
                <base-select
                  v-if="!$store.getters['enums/user_info'].branch"
                  name="Branch"
                  label="branch"
                  :options="$store.getters['enums/branch_enums']"
                  :small="true"
                  field="selected_brand"
                  :value="searchPayload.branch"
                  @change-value="getBranch"
                >
                </base-select>
                <base-select
                  name="category"
                  label="category"
                  :options="$store.getters['enums/reservation_category_enums']"
                  :small="true"
                  field="category"
                  :value="searchPayload.category"
                  @change-value="getCategory"
                >
                </base-select>
                <base-select
                  v-if="!showClientIdInfo"
                  name="Main Client"
                  label="Main Client"
                  :options="mainClientAccountOptions"
                  :small="true"
                  field="mainClient"
                  :value="searchPayload.mainClient"
                  @change-value="getMainClient"
                  :disabled="autofill_client"
                >
                </base-select>

                <base-select
                  v-if="!showClientIdInfo"
                  name="client"
                  label="client"
                  :options="$store.getters['enums/clients_list_enums']"
                  :small="true"
                  field="client"
                  :value="searchPayload.client"
                  @change-value="getClient"
                  :disabled="autofill_client"
                >
                </base-select>

                <base-select
                  name="Service"
                  label="bundle"
                  :options="$store.getters['enums/product_enums']"
                  :small="true"
                  field="selected_brand"
                  :value="searchPayload.product"
                  @change-value="getProduct"
                >
                </base-select>

                <base-select
                  name="Type"
                  label="reservation-type"
                  :options="typeOptions"
                  :small="true"
                  field="selected_brand"
                  :value="searchPayload.type"
                  @change-value="getType"
                  :useI18n="true"
                >
                </base-select>

                <base-select
                  name="Invoice Status"
                  label="invoice-status"
                  :options="receiptStatusOptions"
                  :small="true"
                  field="selected_brand"
                  :value="searchPayload.receiptStatus"
                  @change-value="getReceiptStatus"
                  :useI18n="true"
                >
                </base-select>

                <base-select
                  name="Reservation Status"
                  label="reservation-status"
                  :options="reservationStatusOptions"
                  :small="true"
                  field="selected_brand"
                  :value="searchPayload.status"
                  @change-value="getStatus"
                  :useI18n="true"
                >
                </base-select>

                <div>
                  <label
                    class="datepicker-placeholder"
                    for="datepicker-placeholder"
                  >
                    {{ $t("date-of-reservation") }}
                  </label>
                  <div class="row mt-2">
                    <div class="col-6">
                      <div class="form-label label-text">
                        {{ $t("from") }}
                      </div>
                      <base-date-time-picker
                        :id="modalFromId"
                        name="startDate"
                        :timePicker="false"
                        date_field="startDate"
                        :value="searchPayload"
                        @change-value="setValue"
                        ></base-date-time-picker>
                    </div>
                    <div class="col-6">
                      <div class="form-label label-text">
                        {{ $t("to") }}
                      </div>
                      <base-date-time-picker
                        :id="modalToId"
                        name="endDate"
                        :timePicker="false"
                        date_field="endDate"
                        :value="searchPayload"
                        :minDate="new Date(searchPayload.startDate)"
                        @change-value="setValue"
                        :position="isLangRtl ? 'right' : 'left'"
                        ></base-date-time-picker>
                      </div>
                    </div>
                  </div>
                <base-button
                  class="search-btn primary mt-1 mb-3"
                  @click="search"
                >
                  {{ showDownloadFilters ? $t("export") : $t("search") }}
                </base-button>
                <base-button
                  class="reset-btn mb-3"
                  variant="secondary"
                  @click="resetSearchPayload"
                >
                  {{ showDownloadFilters ? $t("cancel") : $t("reset-filters") }}
                </base-button>
              </div>
            </b-sidebar>
          </div>
        </div>
      </div>
      <div v-if="!group_by_key || group_by_key === 'none'">
        <CommonTable
          :items="items"
          :fields="fields"
          :currentPage="currentPage"
          :typeOptions="typeOptions"
          :receiptStatusOptions="receiptStatusOptions"
          :reservationStatusOptions="reservationStatusOptions"
          :getRowDetailHref="reservationListRowHref"
          @search="search"
          @selectItem="selectItem"
        />
      </div>
      <div v-else>
        <CommonTable
          :items="[]"
          :fields="fields"
          :currentPage="currentPage"
          :typeOptions="typeOptions"
          :receiptStatusOptions="receiptStatusOptions"
          :reservationStatusOptions="reservationStatusOptions"
          :getRowDetailHref="reservationListRowHref"
          @search="search"
          @selectItem="selectItem"
          tbodyClass="d-none"
          @changeParentSorting="changeParentSorting"
        />
        <div v-for="(each, index) in Object.keys(group_by_data)" :key="index">
          <div
            class="mb-3 group-by-block cursor-pointer"
            v-b-toggle="`collapse-group-${index}`"
          >
            <div>
              <span class="label">{{ $t(each) }}</span>
              <span class="count"> ({{ group_by_data[each].length }}) </span>
            </div>
            <img
              :src="require(`@/assets/images/icons/accordian-icon.svg`)"
              alt="accordian-icon"
            />
          </div>
          <b-collapse :id="`collapse-group-${index}`">
            <CommonTable
              :items="group_by_data[each]"
              :fields="fields"
              :currentPage="currentPage"
              :typeOptions="typeOptions"
              :receiptStatusOptions="receiptStatusOptions"
              :reservationStatusOptions="reservationStatusOptions"
              :getRowDetailHref="reservationListRowHref"
              :sortByProp="sortByProp"
              :sortDescProp="sortDescProp"
              theadClass="d-none"
              @search="search"
              @selectItem="selectItem"
            />
          </b-collapse>
        </div>
      </div>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        first-number
        last-number
        aria-controls="my-table"
        class="d-flex justify-content-end"
      ></b-pagination>
    </div>
    <MultiChangeStatus :tripsIds="selectedIds" @refreshData="search" />
    <SuccessModal />
  </div>
</template>

<script>
import moment from "moment";
import NewReservationService from "@/services/new-reservation.service";
import MainClientAccountService from "@/services/main-client-account.service";
import { EventBus } from "./event-bus.js";
import MultiChangeStatus from "./multiChangeStatus.vue";
import SuccessModal from "./SuccessModal";
import CommonTable from "./CommonTable.vue";
import UserService from "@/services/user.service";

export default {
  components: {
    MultiChangeStatus,
    SuccessModal,
    CommonTable,
  },
  props: ["showDownloadFilters", "showClientIdInfo"],
  data() {
    return {
      sortDescProp: false,
      EditHovered: false,
      filterBtnHovered: false,
      loading: false,
      user:[],
      invoiceTabIndex: 0,
      invoiceStatusTabs: [
        { label: this.$t("all-statuses"), value: null },
        { label: this.$t("partially-invoice"), value: "partially-invoice" },
        { label: this.$t("awaiting-invoice"), value: "awaiting-invoice" },
      ],
      perPage: 15,
      currentPage: 1,
      modes: ["single", "range"],
      fields: [
        {
          key: "id",
          label: "#",
          sortable: false,
          selected: true,
          class: "align-middle",
        },
        {
          key: "mainClient",
          label: this.$t("main-client-account"),
          sortable: false,
          selected: true,
          class: "align-middle",
        },
        {
          key: "reference_number",
          label: this.$t("reference-number"),
          sortable: false,
          selected: true,
          class: "align-middle",
        },
        {
          key: "salesOrderNumbers",
          label: this.$t("sales-order-number"),
          sortable: false,
          selected: true,
          class: "align-middle",
        },
        {
          key: "salesOrderName",
          label: this.$t("sales-order-name"),
          sortable: false,
          selected: true,
          class: "align-middle",
        },
        {
          key: "category",
          label: this.$t("category"),
          sortable: false,
          selected: true,
          class: "align-middle",
          thStyle: {
            backgroundPosition: "right 1.9rem center !important",
          },
        },
        {
          key: "client",
          label: this.$t("client"),
          sortable: false,
          selected: true,
          class: "align-middle",
          thStyle: {
            backgroundPosition: "right 1.9rem center !important",
          },
        },
        {
          key: "product",
          label: this.$t("bundle"),
          sortable: false,
          selected: false,
          class: "align-middle",
          thStyle: {
            backgroundPosition: "right 3.575rem center !important",
            minWidth: "200px",
          },
        },
        {
          key: "branch",
          label: this.$t("branch"),
          sortable: false,
          selected: true,
          class: "align-middle",
          thStyle: {
            backgroundPosition: "right 0.975rem center !important",
          },
        },
        {
          key: "created_by",
          label: this.$t("employee-name"),
          selected: true,
          sortable: true,
          class: "align-middle",
          thStyle: {
            minWidth: "150px",
          },
        },
        {
          key: "date_of_initial_reservation",
          label: this.$t("date-initial-reservation"),
          selected: true,
          sortable: false,
          class: "align-middle",
          thStyle: {
            minWidth: "110px",
          },
        },
        {
          key: "number_of_trips",
          label: this.$t("number-of-trips"),
          sortable: false,
          selected: true,
          class: "align-middle",
        },
        {
          key: "totalVehicles",
          label: this.$t("reservation-needed-vehicles"),
          selected: true,
          sortable: false,
          class: "align-middle",
        },
        {
          key: "totalDrivers",
          label: this.$t("reservation-needed-drivers"),
          selected: true,
          sortable: false,
          class: "align-middle",
        },
        {
          key: "finalTotalPriceUntaxed",
          label: `${this.$t("amount-untaxed")} (${this.$t("sar")})`,
          sortable: true,
          selected: true,
          class: "align-middle",
          thStyle: {
            backgroundPosition: "right .1rem center !important",
            paddingRight: "15px !important",
            minWidth: "120px",
          },
        },
        {
          key: "finalPriceIncludingTax",
          label: `${this.$t("total-amount")} (${this.$t("sar")})`,
          sortable: true,
          selected: true,
          class: "align-middle",
          thStyle: {
            backgroundPosition: "right .1rem center !important",
            paddingRight: "15px !important",
            minWidth: "120px",
          },
        },
        {
          key: "type",
          label: this.$t("reservation-type"),
          sortable: false,
          selected: true,
          class: "align-middle",
          thStyle: {
            backgroundPosition: "right 1.9rem center !important",
          },
        },
        {
          key: "receiptStatus",
          label: this.$t("invoice-status"),
          sortable: false,
          selected: true,
          class: "align-middle",
          thStyle: {
            backgroundPosition: "right 3.575rem center !important",
          }
        },
        {
          key: "reservation_status",
          label: this.$t("reservation-status"),
          sortable: false,
          selected: true,
          class: "align-middle",
          thStyle: {
            backgroundPosition: "right 3.575rem center !important",
          },
        },
        {
          key: "details",
          label: this.$t("details"),
          selected: true,
          class: "align-middle",
        },
      ],
      items: [],
      sortByProp: "",
      typeOptions: [
        { text: this.$t("select-an-option"), value: null },
        { text: this.$t("charter"), value: "Charter" },
        { text: this.$t("recurrence"), value: "Recurrence" },
        { text: this.$t("shifts-recurring"), value: "Shift-Recurrence" },
      ],
      receiptStatusOptions: [
        { text: this.$t("select-an-option"), value: null },
        { text: this.$t("awaiting-invoice"), value: "awaiting-invoice" },
        { text: this.$t("partially-invoice"), value: "partially-invoice" },
        { text: this.$t("fully-invoice"), value: "fully-invoice" }
      ],
      reservationStatusOptions: [
        { text: this.$t("select-an-option"), value: null },
        { text: this.$t("draft-quotation"), value: "draft-quotation" },
        { text: this.$t("quotation"), value: "quotation" },
        { text: this.$t("sales-order"), value: "sales-order" },
        { text: this.$t("draft-sales-order"), value: "draft-sales-order" },
        { text: this.$t("rescheduled"), value: "rescheduled" },
        { text: this.$t("waiting-for-approval"), value: "waiting-for-approval" },
        { text: this.$t("canceled"), value: "cancelled" },
        { text: this.$t("blocked"), value: "blocked" },
      ],
      searchPayload: {
        type: null,
        branch: null,
        category: null,
        client: null,
        mainClient: null,
        product: null,
        status: null,
        receiptStatus: null,
        endDate: null,
        startDate: null,
      },
      mainClientAccountOptions: [{ value: null, text: "please-select-option" }],
      variant: "transparent",
      modalFromId: "date-picker-modal1",
      modalToId: "date-picker-modal2",
      dateFromContext: {},
      dateToContext: {},
      selectedIds: [],
      rows: 0,
      autofill_client: false,
      quick_search_key: null,
      quick_search_value: null,
      quick_search_type: null,
      open_form_builder: false,
      open_group_by_menu: false,
      group_by_options: [
        {
          key: "none",
          label: this.$t("none"),
          selected: true,
        },
        {
          key: "category",
          label: this.$t("category"),
          selected: false,
        },
        {
          key: "client",
          label: this.$t("client"),
          selected: false,
        },
        {
          key: "product",
          label: this.$t("bundle"),
          selected: false,
        },
        {
          key: "branch",
          label: this.$t("branch"),
          selected: false,
        },
        {
          key: "created_by",
          label: this.$t("employee-name"),
          selected: false,
        },
        {
          key: "date_of_initial_reservation",
          label: this.$t("date-initial-reservation"),
          selected: false,
        },
        {
          key: "finalTotalPriceUntaxed",
          label: this.$t("amount-untaxed"),
          selected: false,
        },
        {
          key: "type",
          label: this.$t("reservation-type"),
          selected: false,
        },
        {
          key: "reservation_status",
          label: this.$t("reservation-status"),
          selected: false,
        },
      ],
      group_by_key: null,
      group_by_data: null,
    };
  },
  computed: {
    clientInfo() {
      return this.$store.getters["enums/client_info"];
    },
  },
  watch: {
    currentPage() {
      this.search();
    },
    clientInfo: {
      immediate: true,
      handler(info) {
        if (info?._id) {
          this.searchPayload.client = info?._id;
          this.autofill_client = true;
        }
      },
    },
    showDownloadFilters(val) {
      if (val) this.$root.$emit("bv::toggle::collapse", "sidebar-backdrop");
    },
    items: {
      handler() {
        if (this.group_by_key) this.groupByKey(this.group_by_key);
      },
      immediate: true,
    },
  },
  methods: {
    reservationListRowHref(item) {
      if (!item?.id) return "#";
      return this.$router.resolve(`/reservation/${item.id}`).href;
    },
    onInvoiceTabChange() {
      this.currentPage = 1;
      this.searchPayload.receiptStatus =
        this.invoiceStatusTabs?.[this.invoiceTabIndex]?.value || null;
      this.search();
    },
    setValue(val, field) {
      this["searchPayload"][field] = val;
    },
    changeParentSorting(sortBy, sortDesc) {
      this.sortByProp = sortBy;
      this.sortDescProp = sortDesc;
    },
    toggleGroupByMenu() {
      this.open_group_by_menu = !this.open_group_by_menu;
      this.open_form_builder = false;
    },
    selectGroupByOption(option) {
      this.toggleGroupByMenu();
      this.group_by_options = this.group_by_options?.map((each) => {
        if (option.key === each.key) each["selected"] = true;
        else each["selected"] = false;
        return each;
      });
      this.groupByKey(
        this.group_by_options?.find((each) => each.selected)?.key
      );
    },
    groupByKey(key) {
      this.group_by_key = key;
      this.group_by_data =
        key === "none" ? null : this.groupBy(this.items, key);
    },
    toggleFormBuilder() {
      this.open_group_by_menu = false;
      this.open_form_builder = !this.open_form_builder;
    },
    selectField(option) {
      if (
        (this.fields.filter((each) => each.selected).length > 1 &&
          option.selected) ||
        !option.selected
      )
        this.fields = this.fields?.map((each) => {
          if (each.key === option.key) each.selected = !each.selected;
          return each;
        });
    },
    resetFieldSelection() {
      this.fields = this.fields?.map((each) => {
        each.selected = each.key !== "product";
        return each;
      });
    },
    quickSearch(option, value) {
      this.quick_search_key = option?.key;
      this.quick_search_value = value;
      this.quick_search_type = option?.type;
      this.search();
    },
    formatDate(date) {
      return moment(date).locale("en").format("DD-MM-YYYY");
    },
    getBranch(branch) {
      this.searchPayload.branch = branch;
    },
    getCategory(category) {
      this.searchPayload.category = category;
    },
    getMainClient(clientId) {
      this.searchPayload.mainClient = clientId;
    },
    async fetchMainClientAccounts() {
      try {
        const params = new URLSearchParams();
        params.append("select", "name,_id,arabicName,idNumber");
        const response = await MainClientAccountService.search(params);
        const items = response.items || [];
        this.mainClientAccountOptions = [
          { value: null, text: "please-select-option" },
          ...items.map((each) => ({
            value: each._id,
            text: `${each.name || each.arabicName || ""}`,
          })),
        ];
      } catch (err) {
        console.error("fetchMainClientAccounts", err);
      }
    },
    getClient(client) {
      this.searchPayload.client = client;
    },
    getProduct(product) {
      this.searchPayload.product = product;
    },
    getStatus(Status) {
      this.searchPayload.status = Status;
    },
    getReceiptStatus(receiptStatus) {
      this.searchPayload.receiptStatus = receiptStatus;
      const tabIndex = this.invoiceStatusTabs.findIndex(
        (tab) => tab.value === receiptStatus
      );
      if (tabIndex !== -1) this.invoiceTabIndex = tabIndex;
    },
    getType(type) {
      this.searchPayload.type = type;
    },
    async search(resetSearch) {
      this.loading = true;
      this.selectedIds = [];
      let params = new URLSearchParams();
      params.append("sort", "-updated_on");
      if (this.user.length === 0) {
       await this.getUser();
      }
      if (this.quick_search_key && this.quick_search_value) {
        if (this.quick_search_type === "dropdown")
          params.append(this.quick_search_key, this.quick_search_value);
        if (this.quick_search_type === "text") {
          if (this.quick_search_key === "referenceNumber") {
            let valueAfterHash;

            if (this.quick_search_value.includes("#")) {
              const valueParts = this.quick_search_value.split("#");
              valueAfterHash = valueParts[1] || "";
            } else {
              valueAfterHash = this.quick_search_value;
            }
              params.append(this.quick_search_key, "*" + valueAfterHash + "*");

          } else {
            params.append(
              this.quick_search_key,
              "*" + this.quick_search_value + "*"
            );
          }
        }
      }
      if (this.searchPayload.type)
        params.append("type", this.searchPayload.type);
      if (this.searchPayload.product)
        params.append("product", this.searchPayload.product);
      if (this.$store.getters["enums/user_info"].branch) {
        params.append("branch", this.$store.getters["enums/user_info"].branch);
      } else if (this.searchPayload.branch) {
        params.append("branch", this.searchPayload.branch);
      }
      if (this.searchPayload.category)
        params.append("category", this.searchPayload.category);

      if (this.searchPayload.mainClient) {
        params.append("mainAccount", this.searchPayload.mainClient);
      }

      if (this.showClientIdInfo) {
        params.append("client", this.$route?.query?.clientID);
      } else if (this.searchPayload.client) {
        params.append("client", this.searchPayload.client);
      }

      if (this.searchPayload.status)
        params.append("status", this.searchPayload.status);
      if (this.searchPayload.startDate)
        params.append("created_on", "gte:" + moment(this.searchPayload.startDate).locale("en").format("YYYY-MM-DD"));
      if( this.searchPayload.receiptStatus)
        params.append("receiptStatus", this.searchPayload.receiptStatus);
      
      if (this.searchPayload.endDate) {
        const date = new Date(this.searchPayload.endDate);
        date.setHours(24);
        date.setMinutes(59);
        params.append(
          "created_on",
          "lte:" + moment(this.searchPayload.endDate).locale("en").format("YYYY-MM-DD") + "T23:59:59.000Z"
        );
      }

      if (this.showDownloadFilters && !resetSearch) {
        this.$store.dispatch("enums/GET_RESERVATION_FILE", params);
        this.$bvModal.show("reservation-export-modal");
      }

      this.$emit("resetSearch");

      params.append(
        "select",
        "allowUpdate,branch.arabicName,branch.name,branch.arabicName,category.name,category.arabicName,client.name,client.arabicName,client.mainAccount._id,client.mainAccount.name,created_by,created_on,numberOfTrips,totalDrivers,totalVehicles,referenceNumber,salesOrderNumbers,salesOrderName,status,type,product.name,product.arabicName,finalTotalPriceUntaxed,finalPriceIncludingTax,paymentLink,paymentLinkExpiryDate,client.paymentMethod,receiptStatus,reservationCategoryType"
      );
      params.append("page", this.currentPage || 1);
      params.append("limit", this.perPage);
      params.append("type", "ne:Contract");

      try {
        const response = await NewReservationService.search(params);
        const data = response.items?.map((each, index) => {
          return {
            index: index,
            id: each?.id,
            type: each?.type,
            date_of_initial_reservation: this.formatDate(each?.created_on),
            number_of_trips: each?.numberOfTrips || "---",
            reservation_status: each?.status,
            category: this.isLangRtl
              ? each?.category?.arabicName
              : each?.category?.name || "----",
            client: this.isLangRtl
              ? each?.client?.arabicName
              : each?.client?.name || "----",
            mainClient: this.isLangRtl
              ? each?.client?.mainAccount?.arabicName || each?.client?.mainAccount?.name || "----"
              : each?.client?.mainAccount?.name || "----",
            product:
              each?.product
                ?.map((rec) => (this.isLangRtl ? rec?.arabicName : rec?.name))
                .join(",") || "----",
            branch: this.isLangRtl
              ? each?.branch?.arabicName
              : each?.branch?.name || "----",
            categoryId: each?.category?._id,
            categoryName: each?.category?.name,
            categoryArabicName: each?.category?.arabicName,
            clientId: each?.client?._id,
            clientName: each?.client?.name,
            clientArabicName: each?.client?.arabicName,
            mainClientId: each?.client?.mainAccount?._id || null,
            productId: each?.product?._id,
            productName: each?.product?.name,
            productArabicName: each?.product?.arabicName,
            branchId: each?.branch?._id,
            branchArabicName: each?.branch?.arabicName,
            totalDrivers: each?.totalDrivers || "---",
            totalVehicles: each?.totalVehicles || "---",
            created_by: this.user?.find((item) => item?.username.toLowerCase() === each?.created_by.toLowerCase())?.name || "---",
            finalTotalPriceUntaxed: each?.finalTotalPriceUntaxed,
            finalPriceIncludingTax : each?.finalPriceIncludingTax ,
            reference_number: each?.referenceNumber || "---",
            salesOrderNumbers: this.formatList(each?.salesOrderNumbers),
            salesOrderName: each?.salesOrderName || "—",
            allowUpdate: each?.allowUpdate || false,
            paymentLink: each?.paymentLink || null,
            paymentLinkExpiryDate: each?.paymentLinkExpiryDate || null,
            clientPaymentMethod: each?.client?.paymentMethod || null,
            receiptStatus: each?.receiptStatus || null,
            reservationCategoryType: each?.reservationCategoryType || null,
          };
        });
        this.items = data;
        this.rows = response.total;
        this.loading = false;
      } catch (error) {
        this.error = error.message;
        this.loading = false;
      }
    },
    async getUser(){
      UserService.search({ select: "_id,name,username"}).then((response) => {
        this.user = response?.items;
      }).catch((error) => {
        this.error = error.message;
      });
    },
    formatList(values) {
      if (!Array.isArray(values)) return values || "—";
      const filtered = values.filter(Boolean);
      return filtered.length ? filtered.join(", ") : "—";
    },
    selectItem(id) {
      const index = this.selectedIds.indexOf(id);
      if (index === -1) {
        this.selectedIds.push(id);
      } else {
        this.selectedIds.splice(index, 1);
      }
    },
    resetSearchPayload() {
      this.searchPayload.type = null;
      this.searchPayload.branch = null;
      this.searchPayload.category = null;
      if (!this.autofill_client) this.searchPayload.client = null;
      this.searchPayload.product = null;
      this.searchPayload.status = null;
      this.searchPayload.receiptStatus =
        this.invoiceStatusTabs?.[this.invoiceTabIndex]?.value || null;
      this.searchPayload.endDate = null;
      this.searchPayload.startDate = null;
      this.$emit("resetSearch");
      this.search("resetSearch");
    },
  },
  mounted() {
    this.search();
  },
  created() {
    this.getUser();
    this.fetchMainClientAccounts();
    EventBus.$on("search", this.search);
  },
  i18n: {
    messages: {
      en: require("@/services/i18n/locales/en/reservationOperations.json"),
      ar: require("@/services/i18n/locales/ar/reservationOperations.json"),
    },
  },
};
</script>

<style lang="scss">
.operation-table-container {
  .invoice-status-tabs {
    ul.nav.nav-tabs {
      li.nav-item {
        a.nav-link {
          background-color: transparent !important;
          color: var(--color-120) !important;
          font-weight: 700 !important;
          font-size: 14px !important;
          line-height: 35px !important;
          letter-spacing: 0.44px !important;
          border-width: 3px;
          &:hover {
            border-color: transparent !important;
          }
        }
        a.nav-link.active {
          background-color: transparent !important;
          border-color: transparent transparent var(--color-23) transparent !important;
          color: var(--color-17) !important;
          &:hover {
            border-color: transparent transparent var(--color-23) transparent !important;
          }
        }
      }
    }
  }
  .table.b-table {
    tbody {
      tr {
        td {
          .reservation_status-btn {
            font-size: 12px;
            font-weight: 700;
            line-height: 16px;
            letter-spacing: 0.4px;
            border-color: transparent;
            padding: 7px, 10px, 7px, 10px;
            border-radius: 10px;
            width: fit-content;
            white-space: nowrap;
          }
          .reservation_status-btn.Sales-order {
            color: var(--color-06);
            background-color: var(--color-19);
          }
          .reservation_status-btn.Quotation {
            color: var(--color-30);
            background-color: var(--color-18);
          }
          .reservation_status-btn.rescheduled {
            color: var(--color-30);
            background-color: var(--color-18);
          }
          .reservation_status-btn.Draft-sales-order {
            color: var(--color-01);
            background: var(--color-25);
          }
          .reservation_status-btn.waiting-for-approval {
            background: var(--color-48);
            color: var(--color-29);
          }

          .reservation_status-btn.Not,
          .reservation_status-btn.cancelled {
            color: var(--color-07);
            background-color: var(--color-20);
          }

          .reservation_status-btn.Awaiting.invoice {
            background-color: #FFF7E7;
            color: #000;
          }
          .reservation_status-btn.Fully.invoice {
            background-color: #D1FFEF;
            color: #000;
          }
          .reservation_status-btn.Partially.invoice {
            background-color: #D9DFFF;
            color: #000;
          }
          .trips-collapse {
            background: var(--color-21);
            border: 1px solid var(--color-15);
            border-radius: 10px;
            margin-block: 10px;
            padding: 18px 9px;
            box-shadow: 0 2px 3px 0 var(--color-38);

            span.trips-titles {
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              letter-spacing: 0.25px;
              color: var(--color-17);
            }
          }
        }
      }
    }
    .no-arrows {
      min-width: 20px;
    }
  }
  .trips-collapse-section {
    td {
      background: var(--color-21) !important;
      border: unset !important;
      padding-block: unset !important;
    }
  }
  .error-text {
    margin-top: 12px !important;
  }
}
</style>
